import { styled } from '@mui/material';

export const CenterText = styled('div')({
    textAlign: 'center',
});
